export const BUSY = 'Занят';
